import React, { useState } from 'react'
import moment from 'moment'
import _ from 'lodash'
import {
  Div, Icon, Button, RadioGroup, H4, P, SmallText, Input,
} from 'konsys-ui'
import { message, Select } from 'antd'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { Trash2 } from 'lucide-react'
import { BANKS, SUPPLIER, SUPPLIERS } from '../../../constants/graph/query'
import { CREATE_SUPPLIER, UPDATE_SUPPLIER } from '../../../constants/graph/mutation'
import {
  SelectWithLabel, TextareaWithLabel, InputWithLabel, FullPageContainer, TextBetween,
} from '../../../components/common'
import {
  PAYMENT_TYPE, PERSON_TYPE, detailMode, STATUS_TYPE, BANK_ACCOUNT_TYPE,
} from '../constants'
import { theme } from '../../../styles/_variables'
import { verifyFields } from '../../../utils/util-services'
import { bankTextSelector } from '../util-functions'
import history from '../../../history'


const Render = ({
  bankLoading, isCreateMode, infoData,
  bankData, mutationLoading, doAction, props,
}) => {
  const [mutationVariables, setMutationVariables] = useState(isCreateMode ? {
    creditTerm: 30,
    // isVat: true,
  } : {
    name: infoData.supplierDetail.data.name,
    paymentType: infoData.supplierDetail.data.paymentType,
    isVat: infoData.supplierDetail.data.isVat ? 'VAT' : 'NOVAT',
    contactPhoneNumber: infoData.supplierDetail.data.contactPhoneNumber,
    creditTerm: infoData.supplierDetail.data.creditTerm,
  })
  const [banks, setBanks] = useState(isCreateMode ? [{ id: 1 }] : infoData.supplierDetail.data.paymentInfo)
  const baseRequiredFields = [
    mutationVariables.name,
    mutationVariables.paymentType,
    mutationVariables.contactPhoneNumber,
  ]
  const creditRequiredFields = [
    ...baseRequiredFields,
    mutationVariables.creditTerm,
  ]
  const BankAccountType = Object.values(BANK_ACCOUNT_TYPE)
  let tmpBank = []
  return (
    <Div display='flex' flexDirection='column' padding='0 60px'>
      { !isCreateMode
      && <SelectWithLabel
        margin='8px 0'
        title={{
          text: 'สถานะ',
        }}
        select={{
          defaultValue: !isCreateMode ? infoData.supplierDetail.data.status : 'ACTIVE',
          placeholder: 'เลือกสถานะ',
          onChange: e => setMutationVariables({ ...mutationVariables, type: e }),
          options: [{ value: STATUS_TYPE.ACTIVE, text: 'ใช้อยู่' }, { value: STATUS_TYPE.INACTIVE, text: 'เลิกใช้' }],
        }}
      />
      }
      {/* <SelectWithLabel
        margin='8px 0'
        title={{
          text: 'ประเภท *',
        }}
        select={{
          defaultValue: !isCreateMode ? infoData.supplierDetail.data.type : undefined,
          placeholder: 'เลือกประเภท',
          onChange: e => setMutationVariables({ ...mutationVariables, type: e }),
          options: [{ value: PERSON_TYPE.ORDINARY_PERSON, text: 'บุคคลธรรมดา' }, { value: PERSON_TYPE.JURISTIC_PERSON, text: 'นิติบุคคล' }],
        }}
      />
      <InputWithLabel input={{
        defaultValue: !isCreateMode ? infoData.supplierDetail.data.prefix : undefined,
        width: '100%',
        prefix: <Icon icon='prefix far fa-font' />,
      }} onChange={e => setMutationVariables({ ...mutationVariables, prefix: e.target.value })} title={{ text: 'คำนำหน้า' }} /> */}
      <InputWithLabel input={{
        defaultValue: !isCreateMode ? infoData.supplierDetail.data.name : undefined,
        width: '100%',
        prefix: <Icon icon='prefix far fa-signature' />,
      }} onChange={e => setMutationVariables({ ...mutationVariables, name: e.target.value })} title={{ text: 'ชื่อ *' }} />
      <InputWithLabel input={{
        defaultValue: !isCreateMode ? infoData.supplierDetail.data.officeTel : undefined,
        width: '100%',
        prefix: <Icon icon='prefix fal fa-phone-office' />,
      }} onChange={e => setMutationVariables({ ...mutationVariables, officeTel: e.target.value })} title={{ text: 'เบอร์สำนักงาน' }} />
      <InputWithLabel input={{
        defaultValue: !isCreateMode ? infoData.supplierDetail.data.addressUrl : undefined,
        width: '100%',
        prefix: <Icon icon='prefix fal fa-phone-office' />,
      }} onChange={e => setMutationVariables({ ...mutationVariables, addressUrl: e.target.value })} title={{ text: 'ที่อยู่ (URL)' }} />
      <InputWithLabel input={{
        defaultValue: !isCreateMode ? infoData.supplierDetail.data.taxId : undefined,
        width: '100%',
      }} onChange={e => setMutationVariables({ ...mutationVariables, taxId: e.target.value })} title={{ text: 'เลขที่เสียภาษี' }} />
      <Div display='flex' alignItems='center' >
        <SmallText style={{ fontWeight: '500', margin: '0 32px 0 0' }}>รูปแบบการชำระเงิน *</SmallText>
        <RadioGroup
          style={{ margin: '8px 0' }}
          defaultCheckedValue={!isCreateMode ? infoData.supplierDetail.data.paymentType : undefined}
          name='paymentType'
          onChange={e => setMutationVariables({ ...mutationVariables, paymentType: e.target.value })}
          list={[{ value: PAYMENT_TYPE.CASH, text: 'เงินสด', margin: '0 45px 0 0' }, { value: PAYMENT_TYPE.CREDIT, text: 'เครดิต' }]}
        />
      </Div>
      <Div display='flex' alignItems='center'>
        <SmallText style={{ fontWeight: '500', margin: '0 32px 0 0', width: '124px' }}>VAT *</SmallText>
        <RadioGroup
          style={{ margin: '8px 0' }}
          defaultCheckedValue={!isCreateMode ? infoData.supplierDetail.data.isVat ? 'VAT' : 'NOVAT' : undefined}
          name='vat'
          onChange={e => setMutationVariables({ ...mutationVariables, isVat: e.target.value })}
          list={[{ value: 'VAT', text: 'มี VAT', margin: '0 50px 0 0' }, { value: 'NOVAT', text: 'ไม่มี VAT' }]}
        />
      </Div>
      {/* <Div display='flex' alignItems='center'>
      <SmallText style={{ fontWeight: '500', margin: '0 90px 0 0' }}>การคิด VAT</SmallText>
      <RadioGroup
        style={{ margin: '8px 0' }}
        defaultCheckedValue={!isCreateMode ? infoData.supplierDetail.data.isVat ? 'VAT' : 'NOVAT' : undefined}
        name='vat'
        onChange={e => setMutationVariables({ ...mutationVariables, isVat: e.target.value === 'VAT' })}
        list={[{ value: 'VAT', text: 'เก็บ VAT', margin: '0 32px 0 0' }, { value: 'NOVAT', text: 'ไม่เก็บ VAT' }]}
      />
      </Div> */}
      {
        mutationVariables.paymentType === PAYMENT_TYPE.CREDIT
        && <Div display='flex' flexDirection='column' padding='8px' margin='8px 0' style={{ border: `1px solid ${theme.color.lightBlue}`, borderRadius: 5 }}>
          {/* <InputWithLabel input={{
            defaultValue: !isCreateMode ? infoData.supplierDetail.data.creditLimit : undefined,
            width: '100%',
            prefix: <Icon icon='prefix far fa-credit-card-blank' />,
            rule: { type: 'float' },
            state: 'default',
          }} onChange={e => setMutationVariables({ ...mutationVariables, creditLimit: parseFloat(e.target.value) })} title={{ text: 'วงเงิน *' }} />
          <InputWithLabel input={{
            defaultValue: !isCreateMode ? infoData.supplierDetail.data.creditUsage : 0,
            width: '100%',
            prefix: <Icon icon='prefix far fa-credit-card-blank' />,
            rule: { type: 'float' },
            state: 'default',
          }} onChange={e => setMutationVariables({ ...mutationVariables, creditUsage: parseFloat(e.target.value) })} title={{ text: 'วงเงินที่ใช้ไปแล้ว' }} /> */}
          <InputWithLabel input={{
            defaultValue: !isCreateMode ? infoData.supplierDetail.data.creditTerm : 30,
            width: '100%',
            prefix: <Icon icon='prefix far fa-calendar-alt' />,
            rule: { type: 'int' },
            state: 'default',
          }} onChange={e => setMutationVariables({ ...mutationVariables, creditTerm: parseInt(e.target.value, 10) })} title={{ text: 'ระยะเครดิต *' }} />
        </Div>
      }
      <InputWithLabel input={{
        defaultValue: !isCreateMode ? infoData.supplierDetail.data.contactName : undefined,
        width: '100%',
        prefix: <Icon icon='prefix far fa-signature' />,
      }} onChange={e => setMutationVariables({ ...mutationVariables, contactName: e.target.value })} title={{ text: 'ชื่อผู้ติดต่อ' }} />
      <InputWithLabel input={{
        defaultValue: !isCreateMode ? infoData.supplierDetail.data.contactPhoneNumber : undefined,
        width: '100%',
        prefix: <Icon icon='prefix far fa-mobile' />,
      }} onChange={e => setMutationVariables({ ...mutationVariables, contactPhoneNumber: e.target.value })} title={{ text: 'เบอร์ผู้ติดต่อ *' }} />
      <InputWithLabel input={{
        defaultValue: !isCreateMode ? infoData.supplierDetail.data.contactFaxNumber : undefined,
        width: '100%',
        prefix: <Icon icon='prefix far fa-fax' />,
      }} onChange={e => setMutationVariables({ ...mutationVariables, contactFaxNumber: e.target.value })} title={{ text: 'แฟกซ์ผู้ติดต่อ' }} />
      <InputWithLabel input={{
        defaultValue: !isCreateMode ? infoData.supplierDetail.data.contactEmail : undefined,
        width: '100%',
        prefix: <Icon icon='prefix far fa-envelope' />,
      }} onChange={e => setMutationVariables({ ...mutationVariables, contactEmail: e.target.value })} title={{ text: 'อีเมลผู้ติดต่อ' }} />
      <InputWithLabel input={{
        defaultValue: !isCreateMode ? infoData.supplierDetail.data.contactLineId : undefined,
        width: '100%',
        prefix: <Icon icon='prefix fab fa-line' />,
      }} onChange={e => setMutationVariables({ ...mutationVariables, contactLineId: e.target.value })} title={{ text: 'Line ID ผู้ติดต่อ' }} />
      <TextareaWithLabel
        width='80%'
        onChange={e => setMutationVariables({ ...mutationVariables, contactRemark: e.target.value })} title={{
          text: 'หมายเหตุ',
          margin: '0 0 8px',
        }} textarea={{
          defaultValue: !isCreateMode ? infoData.supplierDetail.data.contactRemark : undefined,
          style: { width: '100%' },
          rows: 8,
          margin: '16px 0 0',
        }}
      />
      <Div display='flex' flexDirection='column' padding='8px' margin='8px 0' style={{ border: `1px solid ${theme.color.lightBlue}`, borderRadius: 5, background: theme.color.veryLightBlue }}>
        <P bold margin='0 0 16px 0'>ข้อมูลธนาคาร</P>
        <Div display='flex'>
          <SmallText bold style={{ width: '40%' }} margin='0 16px 0 0'>ธนาคาร</SmallText>
          <SmallText bold style={{ width: '100%' }} margin='0 16px 0 0'>ชื่อบัญชี</SmallText>
          <SmallText bold style={{ width: '100%' }} margin='0 16px 0 0'>เลขที่บัญชี</SmallText>
          <Div width='31.25px' />
        </Div>
        {
          banks.map((bank, index) => (
            <Div key={bank.id} display='flex' alignItems='center' margin='0 0 16px 0'>
              <Select
                loading={bankLoading}
                style={{ width: '40%', margin: '0 16px 0 0' }}
                defaultValue= {!isCreateMode && infoData.supplierDetail.data.paymentInfo ? banks[index].bankId : undefined}
                placeholder='เลือกธนาคาร'
                // onChange={e => setMutationVariables({ ...mutationVariables, bankId: e })}
                onChange={(e) => {
                  tmpBank = banks
                  tmpBank[index] = {
                    ...tmpBank[index],
                    bankId: e,
                  }
                  setBanks(tmpBank)
                }}
                // options={!_.isUndefined(bankData) ? bankData.bankList.data.list.map(v => ({ text: v.name, value: v.id })) : []}
              >
                {
                  !_.isUndefined(bankData) ? bankData.bankList.data.list.map(v => <Select.Option key={v.id} value={v.id}>{v.name}</Select.Option>) : []
                }
              </Select>
              <Input
                width='100%'
                margin='0 16px 0 0'
                prefix={<Icon icon='prefix far fa-money-check-edit-alt' />}
                defaultValue= {!isCreateMode && infoData.supplierDetail.data.paymentInfo ? banks[index].bankAccountName : undefined}
                onChange={(e) => {
                  tmpBank = banks
                  tmpBank[index] = {
                    ...tmpBank[index],
                    bankAccountName: e.target.value,
                  }
                  setBanks(tmpBank)
                }}
              />
              <Input
                width='100%'
                margin='0 16px 0 0'
                prefix={<Icon icon='prefix far fa-envelope' />}
                defaultValue= {!isCreateMode && infoData.supplierDetail.data.paymentInfo ? banks[index].bankAccountNumber : undefined}
                onChange={(e) => {
                  tmpBank = banks
                  tmpBank[index] = {
                    ...tmpBank[index],
                    bankAccountNumber: e.target.value,
                  }
                  setBanks(tmpBank)
                }}
              />
              <Select
                style={{ width: '40%', margin: '0 16px 0 0' }}
                // defaultValue: !isCreateMode && infoData.supplierDetail.data.bank ? infoData.supplierDetail.data.bank.id : undefined,
                placeholder='เลือกประเภทบัญชี'
                defaultValue= {!isCreateMode && infoData.supplierDetail.data.paymentInfo ? banks[index].bankAccountType : undefined}
                onChange={(e) => {
                  tmpBank = banks
                  tmpBank[index] = {
                    ...tmpBank[index],
                    bankAccountType: e,
                  }
                  setBanks(tmpBank)
                }}
              >
                {
                  BankAccountType.map(v => <Select.Option key={v} value={v}>{bankTextSelector(v)}</Select.Option>)
                }
              </Select>
              <Trash2 className='cursor-pointer text-black' onClick={() => setBanks(_.remove(_.cloneDeep(banks), o => o.id !== bank.id))}/>
            </Div>
          ))
        }
        <Button onlyIcon icon='fal fa-plus' margin='16px auto' inverse onClick={() => {
          if (banks.length === 0) setBanks([{ id: 1 }])
          else setBanks([...banks, { id: _.maxBy(banks, 'id').id + 1 }])
        }} />
      </Div>
      <Button
        disabled={mutationLoading || (mutationVariables.paymentType === 'CASH'
          ? verifyFields(isCreateMode, baseRequiredFields, mutationVariables)
          : verifyFields(isCreateMode, creditRequiredFields, mutationVariables))}
        loading={mutationLoading}
        text={isCreateMode ? 'สร้างผู้ผลิต' : 'แก้ไขผู้ผลิต'}
        icon={isCreateMode ? 'far fa-plus' : 'far fa-edit'}
        style={{ alignItems: 'center' }}
        width='150px'
        margin='20px auto'
        onClick={() => {
          tmpBank = _.cloneDeep(banks).map(v => _.omit(v, ['__typename']))
          doAction({
            variables:
            isCreateMode
            ? { ...mutationVariables, paymentInfo: banks, isVat: mutationVariables.isVat === 'VAT' }
            : {
              ...mutationVariables, paymentInfo: tmpBank, id: parseInt(props.match.params.id, 10), isVat: mutationVariables.isVat === 'VAT',
            },
            refetchQueries: [{ query: SUPPLIERS, variables: { limit: 5, offset: 0 } }],
          }).then((resp) => {
            const KEY = isCreateMode ? 'createSupplier' : 'updateSupplier'
            if (resp.data[KEY].success) {
              message.success(resp.data[KEY].message)
              history.push('/supplier')
            } else message.error(resp.data[KEY].message)
          })
        }}
      />
    </Div>
  )
}

export default ({ props }) => {
  const isCreateMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const { data: bankData, loading: bankLoading, error } = useQuery(BANKS)
  // const { data: pricingData, loading: pricingLoading, error: pricingError } = useQuery(PRICINGTYPES)
  const [doAction, { loading: mutationLoading }] = useMutation(isCreateMode ? CREATE_SUPPLIER : UPDATE_SUPPLIER)
  const { loading, data, error: infoError } = useQuery(SUPPLIER, { skip: isCreateMode, variables: { id: parseInt(props.match.params.id, 10) } })

  return (
    <Div>
      {
        !loading
          ? !isCreateMode && _.isNull(data.supplierDetail.data)
            ? <H4>ไม่พบ</H4>
            : <Render
              bankLoading={bankLoading}
              isCreateMode={isCreateMode}
              infoData={data}
              bankData={bankData}
              mutationLoading={mutationLoading}
              doAction={doAction}
              props={props}
            />
          : null
      }
    </Div>
  )
}
